import React, { useEffect, useState } from 'react';
import Mixpanel from "mixpanel-browser";
import ReactTable from '../../common/react-table/ReactTable';
import trashImg from "../../assets/images/trash.svg";
import ActionImg from "../../assets/images/action.svg";
import edit from "../../assets/images/edit.svg";
import { getUserList } from '../../features/userManagement/getUserListSlice';
import { useDispatch, useSelector } from 'react-redux';
import UserVerify from './modal/UserVerify';
import moment from 'moment';
import active_icon from '../../assets/images/active_icon.svg';
import { deleteUser } from '../../features/userManagement/deleteUserSlice';
import { OK } from '../../constants/statusCode';
// import { showSuccess } from '../../utils/messageHelper';
import AddUserModal from './modal/AddUserModal';
import ConfirmationModal from '../../common/modal/ConfirmationModal';
import { resetData } from '../../features/userManagement/getParticularUserSlice';

const Pending = ({ searchValue, currentActiveTab, setCurrentModal, currentModal, setCurrentActiveTab }) => {

  const { userList, total_records } = useSelector((state) => ({
    userList: state?.getUserListReducer?.responseData?.users,
    total_records: state?.getUserListReducer?.responseData?.pagination?.total_records,
  }));

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [userUUID, setUserUUID] = useState('');
  const [userEmail, setUserEmail] = useState('');
  let projectData = JSON.parse(localStorage.getItem("_user"));
  const dispatch = useDispatch();

  const toggleFunction = () => {
    setCurrentModal("");
    setUserUUID("");
    dispatch(resetData());
  };

  useEffect(() => {
    if (currentActiveTab === 'pending') {
      dispatch(getUserList({ perPage: perPage, page: currentPage, search: searchValue, isActive: 0, organization_uuid: projectData?.organizations[0].uuid }));
    }
  }, [perPage, currentPage, searchValue, currentActiveTab]);

  const handleDelete = async () => {
    Mixpanel.track("Delete user Button Clicked", {
      Page: "Users page",
    });
    const { payload } = await dispatch(deleteUser({ userId: userUUID, organization_uuid: projectData?.organizations[0].uuid }));
    if (payload.status === OK) {
      dispatch(getUserList({ perPage: perPage, page: currentPage, isActive: 0, organization_uuid: projectData?.organizations[0].uuid }));
      toggleFunction();
      setCurrentActiveTab("pending");
      // showSuccess(payload.data.responseMessage);
    }
  };

  const handleTotalPage = (page) => {
    setPerPage(Number(page));
    setCurrentPage(1);
  };

  const handleCurrentPage = (page) => {
    setCurrentPage(Number(page));
  };

  const columns = [
    {
      Header: 'Email',
      accessor: 'email',
      /*  Cell: (data) => {
           return (
               <>
                   <span>Rakesh_p@gmail.com</span>
               </>
           )
       } */
    },
    {
      Header: 'Full Name',
      accessor: (data) => (
        <>
          <span>{data?.first_name}{" "}{data?.last_name}</span>
        </>
      ),
    },
    {
      Header: 'Created At',
      accessor: (data) => (
        <>
          <span>{moment(data?.created_at).format('MMM DD, yyyy hh:mm A')}</span>
        </>
      ),
    },
    {
      Header: 'Role',
      accessor: (data) => (
        <>
          {data?.Roles?.map((role) => {
            return (<span key={role?.id}>{role.name}</span>)
          })
          }
        </>
      ),
    },
    {
      Header: 'User Group',
      accessor: 'userGroup'
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: () => {
        return (
          <>
            {/* <img src="images/status-sync.svg" alt="" /> */}
            <span className="active-btn light-gray">Pending</span>
          </>
        )
      }
    },
    {
      Header: 'Action',
      accessor: 'Action',
      disableSortBy: true,
      Cell: (data) => {
        return (
          <div className="dropdown action-dropdown user-table-dropdown">
            <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <img src={ActionImg} alt="" />
            </button>
            <ul className="dropdown-menu">
              <li
                className='dropdown-item mt-1'
                onClick={() => {
                  setCurrentModal('userVerify');
                  setUserUUID(data?.row?.original?.uuid);
                  setUserEmail(data?.row?.original?.email);
                }}
              >
                <span><img className="trnsfomr user-table-drow-img" src={active_icon} alt="" /></span>
                Activate
              </li>
              <li
                className='dropdown-item mt-1'
                onClick={() => {
                  setCurrentModal("editUserModal");
                  setUserUUID(data?.row?.original?.uuid);
                }}
              >
                <span><img src={edit} alt="" /></span>
                Edit
              </li>
              <li
                className='dropdown-item mt-1'
                onClick={() => {
                  setCurrentModal("deleteUserModal");
                  setUserUUID(data?.row?.original?.uuid);
                }}
              >
                <span><img src={trashImg} alt="" /></span>
                Delete
              </li>
            </ul>
          </div>
        )
      }
    }
  ];

  return (
    <div>
      <ReactTable
        columns={columns}
        data={userList?.length > 0 ? userList : []}
        currentPage={currentPage}
        perPage={perPage}
        totalCount={total_records}
        handlePerPage={handleTotalPage}
        // isCheckBox={true}
        onPageChange={(page) => {
          handleCurrentPage(page);
        }}
        className="mangeuser-table"
      />
      {currentModal === 'userVerify' &&
        <UserVerify
          isOpen={currentModal === 'userVerify'}
          toggel={toggleFunction}
          userUUID={userUUID}
          userEmail={userEmail}
          perPage={perPage}
          currentPage={currentPage}
          setCurrentActiveTab={setCurrentActiveTab}
        />
      }
      {currentModal === "deleteUserModal" && (
        <ConfirmationModal
          title={"Delete Confirmation"}
          isOpen={currentModal === "deleteUserModal"}
          toggle={toggleFunction}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this user?"
        />
      )}
      {currentModal === "editUserModal" && (
        <AddUserModal
          toggleFunction={toggleFunction}
          isVisible={currentModal === "editUserModal"}
          userId={userUUID}
          setCurrentActiveTab={setCurrentActiveTab}
          isFromAllUsers={false}
        />
      )}
    </div>
  )
}

export default Pending;
